import theme from '@vromo/ui/components/theme';

export default {
    container: {
        backgroundColor: 'rgb(243, 243, 243)',
        marginBottom: '20px',
        paddingLeft: 20,
        paddingRight: 20,
        paddingBottom: 20,
        borderRadius: 4
    },
    title: {
        marginLeft: 4,
        marginRight: 16,
        marginTop: 12,
        color: theme.darkText
    },
    resultTitle: {
        color: theme.darkText
    },
    percentageTitle: {
        color: theme.darkText
    },
    restaurantName: {
        marginLeft: 16,
        color: theme.darkText
    },
    editButtonContainer: { flex: 1 },
    zipCodeList: {
        marginTop: 12,
        marginBottom: 16,
        width: '100%',
        maxHeight: '220px',
        overflowY: 'auto'
    },
    nameTitle: {
        paddingLeft: 48,
        color: theme.darkText
    },
    editContainer: {
        backgroundColor: 'rgb(243, 243, 243)',
        marginBottom: '20px',
        padding: 20,
        borderRadius: 4
    },
    removeIconContainer: {
        position: 'relative'
    },
    iconWrapper: {
        position: 'absolute',
        right: 0,
        top: 0
    },
    removeIcon: {
        marginLeft: 6,
        cursor: 'pointer',
        color: theme.grey
    },
    inputsContainer: {
        display: 'flex'
    },
    nameInput: {
        width: 240
    },
    zipCodeInput: {
        width: '100%',
        height: '220px'
    }
};
